import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ShortcutIcon from "@mui/icons-material/Shortcut";

const EmailContent = ({ handleOpenReply }: any) => {
  return (
    <Box>
      <Box
        sx={{
          paddingBottom: "30px",
          marginBottom: "15px",
        }}
      >
        <Typography>
          Hi Cheyenne, thank you for contacting yi tech support. we understand
          that you are facing issues while login through facebook. we apologise
          for the inconvenience. we request you to send us the screenshot of the
          error message which you are getting so that we we can investigate on
          the issue ad help you with the resolution.
        </Typography>

        <Typography
          sx={{
            marginTop: "30px",
          }}
        >
          {`regarding the motion detection issue we request you to check this following settings:
-verify that your **alert notifications** in yi home app is turned on:
open yi home app > camera _settings_ > _smart detection settings_ > toggle _motion detection_ on`}
        </Typography>

        <Typography
          sx={{
            marginTop: "30px",
          }}
        >
          for further assistance, please reply to the email or visit us at
          https://help.yitechnology.com/hc/en-us
        </Typography>

        <Typography>----</Typography>

        <Typography
          sx={{
            marginTop: "30px",
          }}
        >
          Regards,
        </Typography>

        <Typography
          sx={{
            marginTop: "5px",
          }}
        >
          Kianna Rosser
        </Typography>

        <Typography
          sx={{
            marginTop: "5px",
          }}
        >
          customer support
        </Typography>
      </Box>

      <Box
        display="flex"
        gap="15px"
        sx={{
          borderBottom: "1px solid #E9E9E9",
          paddingBottom: "30px",
          marginBottom: "15px",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            borderColor: "#757775",
            padding: "10pxpx!important",
          }}
        >
          Thank you so much
        </Button>
        <Button
          variant="outlined"
          sx={{
            borderColor: "#757775",
            padding: "0px 25px!important",
          }}
        >
          Thanks for the update.
        </Button>
      </Box>

      <Box display="flex" gap="15px">
        <Button
          variant="outlined"
          sx={{
            color: "#757775",
            borderRadius: "20px!important",
            borderColor: "#757775",
            padding: "10pxpx!important",
          }}
          startIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.28009 0.969592C4.4207 1.11024 4.49968 1.30097 4.49968 1.49984C4.49968 1.69871 4.4207 1.88944 4.28009 2.03009L2.56034 3.74984H6.74985C8.14223 3.74984 9.4776 4.30297 10.4621 5.28753C11.4467 6.27207 11.9999 7.60744 11.9999 8.99982V10.4998C11.9999 10.6987 11.9208 10.8895 11.7802 11.0301C11.6396 11.1708 11.4488 11.2498 11.2499 11.2498C11.051 11.2498 10.8602 11.1708 10.7195 11.0301C10.5788 10.8895 10.4999 10.6987 10.4999 10.4998V8.99982C10.4999 8.00524 10.1048 7.05147 9.40148 6.3482C8.6982 5.64493 7.74443 5.24984 6.74985 5.24984H2.56034L4.28009 6.96957C4.35173 7.03879 4.40886 7.12152 4.44817 7.21302C4.48748 7.30452 4.50816 7.40299 4.50903 7.50252C4.50989 7.60212 4.49092 7.70089 4.45321 7.79307C4.4155 7.88524 4.3598 7.96895 4.28939 8.03937C4.21897 8.1098 4.13523 8.16552 4.04306 8.20324C3.95088 8.24089 3.85212 8.25987 3.75254 8.25904C3.65296 8.25814 3.55454 8.23744 3.46304 8.19814C3.37154 8.15884 3.28877 8.10169 3.21959 8.03007L0.219592 5.03009C0.07899 4.88944 0 4.69871 0 4.49984C0 4.30097 0.07899 4.11024 0.219592 3.96959L3.21959 0.969592C3.36023 0.82899 3.55097 0.75 3.74984 0.75C3.94871 0.75 4.13945 0.82899 4.28009 0.969592Z"
                fill="#757775"
              />
            </svg>
          }
          onClick={handleOpenReply}
        >
          Reply
        </Button>
        <Button
          variant="outlined"
          sx={{
            color: "#757775",
            borderRadius: "20px!important",
            borderColor: "#757775",
            padding: "0px 25px!important",
          }}
          startIcon={
            <ShortcutIcon
              sx={{
                color: "#757775",
                fontSize: "12px",
              }}
            />
          }
        >
          Forward
        </Button>
      </Box>
    </Box>
  );
};

export default EmailContent;
